module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bxVMn"))).then(() => parcelRequire('1iHdE'));